module.exports = __webpack_public_path__ + "static/media/18ECA45.d1d92383.jpg";